<template>
  <div class="app" :class="{'blue-backgroud h-100': showElements}">
    <Header  v-if="!userIsLoggedIn() && !showElements" :show-collapse="!showElements" />
    <DashHeader v-if="userIsLoggedIn() && !showElements" />
    <router-view />
    <Footer v-if="!userIsLoggedIn() && !showElements" :show-footer="!showElements" />
    <DashFooter v-if="userIsLoggedIn()" />
  </div>
</template>

<script>
import Footer from "@/components/common/Footer";
import Header from "@/components/common/Header";
import DashHeader from "@/components/common/DashHeader";
import DashFooter from "@/components/common/DashFooter";
import { userIsLoggedIn } from "@/services/utils";
import { mapState } from "vuex";

export default {
  name: "App",
  methods: {
    userIsLoggedIn
  },
  data: () => ({
      quickTourOptions: {
        labels: {
          buttonStop: "Don't show this again"
        }
      }
    }
  ),
  computed: {
    ...mapState(["currentUser"]),
    showElements() {
      const hideElements = ['TakeSurvey']
      return hideElements.includes(this.$route.name);
    }
  },
  components: { Footer, Header,DashHeader,DashFooter }
};
</script>

<style lang="less">
@import "./assets/general/TorchMetrics.less";
</style>
